export default "__VITE_ASSET__CzHHKkH5__"